// extracted by mini-css-extract-plugin
export default {"sidebar":"WorkflowActions_sidebar__-uc+1","sidebarActionItem":"WorkflowActions_sidebarActionItem__0NUcg"};